export default __webpack_public_path__ + "static/media/add_user_Page.266863fe.svg";